import { useState } from "react";
import { Outlet } from "react-router-dom";

import { CommandPalette } from "@/components/command-palette";
import { ImpersonationBanner } from "@/components/impersonation-banner";
import { KeyboardShortcutsDialog } from "@/components/keyboard-shortcuts";
import { Header } from "@/components/layout/header";
import { Sidebar } from "@/components/layout/sidebar";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { TooltipProvider } from "@/components/ui/tooltip";

export function AppShell() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <TooltipProvider delayDuration={200}>
      <div className="min-h-dvh bg-background text-foreground antialiased relative">
        {/* Ambient background */}
        <div aria-hidden className="pointer-events-none fixed inset-0 -z-10">
          <div className="absolute top-0 left-1/2 h-[600px] w-[800px] -translate-x-1/2 -translate-y-1/3 rounded-full bg-primary-100/40 dark:bg-primary-900/10 blur-3xl" />
        </div>

        <Header onMenuClick={() => setMobileOpen(true)} />
        <ImpersonationBanner />
        <div className="flex">
          <Sidebar />
          <main
            id="main"
            className="flex-1 min-w-0 px-4 py-8 sm:px-6 lg:px-10 animate-fade-in"
          >
            <div className="mx-auto max-w-7xl">
              <Outlet />
            </div>
          </main>
        </div>

        {/* Mobile drawer */}
        <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
          <SheetContent side="left" size="sm" className="p-0">
            <Sidebar onItemClick={() => setMobileOpen(false)} withHeader alwaysVisible />
          </SheetContent>
        </Sheet>

        <CommandPalette />
        <KeyboardShortcutsDialog />
      </div>
    </TooltipProvider>
  );
}
